module.exports = __webpack_public_path__ + "static/media/mr-skin-da4931d0.c10bb9de.jpg";